import { version } from '../package.json'
import './styles/index.scss'
import './js/App'

console.log(
	`%c
█████████      ███████████ █████████  █████████        ████████████████████████
█████████    ██████████    █████████  █████████        ████████████████████████
█████████  █████████       █████████  █████████        █████████      █████████
██████████████████         █████████  █████████        █████████      █████████
████████████████████       █████████  █████████        █████████      █████████
█████████  ███████████     █████████  █████████        █████████      █████████
█████████    ███████████   █████████  ████████████████ ████████████████████████
█████████      ███████████ █████████  ████████████████ ████████████████████████

█████████      ███████████ █████████  █████████        ████████████████████████
█████████    ██████████    █████████  █████████        ████████████████████████
█████████  █████████       █████████  █████████        █████████      █████████
██████████████████         █████████  █████████        █████████      █████████
████████████████████       █████████  █████████        █████████      █████████
█████████  ███████████     █████████  █████████        █████████      █████████
█████████    ███████████   █████████  ████████████████ ████████████████████████
█████████      ███████████ █████████  ████████████████ ████████████████████████

`,
	'color:black;',
	'https://www.kilokilo.agency'
)

console.log(version)
